import React, {useState} from 'react';
import {FormattedMessage, useIntl} from "react-intl";
import {VisitRequestDto} from "../../../../../modules/vms/dto/VisitRequestDto";
import Descriptions from "../../../../../components/Descriptions";
import DescriptionItem from "../../../../../components/DescriptionItem";
import {Button, Card, CardContent, CardHeader} from "@mui/material";
import StringUtils from "../../../../../utils/StringUtils";
import {RequestVisitorDto} from "../../../../../modules/vms/dto/RequestVisitorDto";
import {VisitorStatus} from "../../../../../modules/vms/enums/VisitorStatus";
import {HttpStatus} from "../../../../../modules/common/enums/HttpStatus";
import QRCodeDialog from "./QRCodeDialog";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import {VisitRequestApi} from "../../../../../modules/vms/api/VisitRequestApi";
import {MessageUtils} from "../../../../../utils/MessageUtils";


export type VisitorDetailCardProps = {
    visitRequest?: VisitRequestDto;
    requestVisitor: RequestVisitorDto;
    onRefresh: () => void;
};

const MyVisitorDetailCard: React.FC<VisitorDetailCardProps> = (props) => {
    const intl = useIntl();

    const [openQRCodeDialog, setOpenQRCodeDialog] = useState(false);


    // const _handleShowQRCode =  (visitCode: string) => {
    //     const redirectUrl = QRCODE_PAGE_PATH.replace('${QRCODE}',visitCode);
    //
    //     window.location.href = redirectUrl;
    //
    // };
    const _handleShowQRCode = () => {
        setOpenQRCodeDialog(true);
    }
    const _handleWithdraw = async () => {

        if (props.visitRequest?.id) {
            const responseResult = await VisitRequestApi.withdraw(props.visitRequest?.id);
            if (responseResult.status === HttpStatus.SUCCESS) {
                MessageUtils.success(intl.formatMessage({id: 'VMS_VISIT_REQUEST_WITHDRAW_SUCCESS'}));
                props.onRefresh()
            }
        }
    }
    let host2nd = "";
    let host2Json;
    if (props.visitRequest && props.visitRequest.remarks) {
        host2Json = JSON.parse(props.visitRequest.remarks);
        if (host2Json) {
            host2nd = host2Json.hostName2 + "," + host2Json.hostDepartmentName2
        }
    }


    const carryGoods = props.requestVisitor.carryGoods;
    let carryGoodsJson;
    if (carryGoods) {
        carryGoodsJson = JSON.parse(carryGoods);
    }
    const visitPlaces = props.visitRequest?.places.map(p => p.areaName).join(',');


    return (
        <Card>

            <QRCodeDialog open={openQRCodeDialog}
                          code={props.requestVisitor.visitCode}
                          onClose={() => setOpenQRCodeDialog(false)}/>
            <CardHeader title={props.visitRequest?.number}/>
            <CardContent>
                <Descriptions column={1}>

                    <DescriptionItem label={intl.formatMessage({id: 'VMS_VISIT_REQUEST_HOST_NAME'})}>
                        {props.visitRequest?.hostFullName}
                    </DescriptionItem>
                    <DescriptionItem label={intl.formatMessage({id: 'VMS_VISIT_REQUEST_HOST_DEPARTMENT_NAME'})}>
                        {props.visitRequest?.hostDepartmentName}
                    </DescriptionItem>
                    <DescriptionItem label={intl.formatMessage({id: 'VMS_VISIT_REQUEST_ARRIVE_DATE'})}>
                        {StringUtils.formatDate(props.visitRequest?.arriveStartDate)}
                    </DescriptionItem>
                    <DescriptionItem label={intl.formatMessage({id: 'VMS_VISIT_REQUEST_PURPOSE'})}>
                        {props.visitRequest?.purpose}
                    </DescriptionItem>
                    <DescriptionItem label={intl.formatMessage({id: 'VMS_VISIT_REQUEST_PLACE'})}>
                        {visitPlaces}
                    </DescriptionItem>
                    <DescriptionItem label={intl.formatMessage({id: 'VMS_REQUEST_VISITOR_PLATE_NUMBER'})}>
                        {props.requestVisitor.plateNumber}
                    </DescriptionItem>
                    <DescriptionItem label={intl.formatMessage({id: 'VMS_VISIT_REQUEST_TRANSPORT_GOODS'})}>
                        {carryGoodsJson && carryGoodsJson.transportGoods}
                    </DescriptionItem>
                    <DescriptionItem label={intl.formatMessage({id: 'VMS_VISIT_REQUEST_PERSONAL_GOODS_DESCRIPTION'})}>
                        {carryGoodsJson && carryGoodsJson.personalGoodsDescription}
                    </DescriptionItem>

                    <DescriptionItem label={intl.formatMessage({id: 'VMS_REQUEST_VISITOR_VISIT_CODE'})}>
                        {props.requestVisitor.visitCode} &nbsp; &nbsp;
                        {props.requestVisitor.status == VisitorStatus.Enum.WaitingCheckIn ?
                            <a href={'javascript:void(0)'}
                               onClick={() => _handleShowQRCode()}><FormattedMessage
                                id={'VMS_REQUEST_VISITOR_VISIT_CODE_QRCODE'}/></a> : null
                        }
                    </DescriptionItem>
                    <DescriptionItem label={intl.formatMessage({id: 'VMS_REQUEST_VISITOR_STATUS'})}>
                        <FormattedMessage id={VisitorStatus.Map.get(props.requestVisitor.status)}/>
                    </DescriptionItem>
                    <DescriptionItem label={intl.formatMessage({id: 'VMS_REQUEST_VISITOR_ACCESS_IN_TIME'})}>
                        {StringUtils.formatDate(props.requestVisitor.accessInLog?.accessDate) + " " + StringUtils.formatTime(props.requestVisitor.accessInLog?.accessTime)}
                    </DescriptionItem>
                    <DescriptionItem label={intl.formatMessage({id: 'VMS_REQUEST_VISITOR_ACCESS_OUT_TIME'})}>
                        {StringUtils.formatDate(props.requestVisitor.accessOutLog?.accessDate) + " " + StringUtils.formatTime(props.requestVisitor.accessOutLog?.accessTime)}
                    </DescriptionItem>
                    <DescriptionItem label={intl.formatMessage({id: 'VMS_VISIT_REQUEST_HOST_2ND'})}>
                        {host2nd}
                    </DescriptionItem>
                    <Button  size="small" variant="outlined" fullWidth={true}
                            disabled={props.requestVisitor.status !== VisitorStatus.Enum.Default}
                            onClick={()=>_handleWithdraw()}>
           <FormattedMessage id={"VMS_VISITOR_BTN_WITHDRAW"}/>
                    </Button>

                </Descriptions>
            </CardContent>
        </Card>
    );
};

export default MyVisitorDetailCard;
